module.exports = __webpack_public_path__ + "static/media/boatsFooter.dfb89d92.png";